import { useAuth } from "m2m-components/storage/useM2mAuth"

export { useAuth }
